import {gql} from '@apollo/react-hooks'

const GameSubscription = gql(`
subscription($id: ID!) {
  onUpdateGame(id : $id) {
    id
    DateStart
    DateEnd
    RoundTotal
    RoundCurrent
    QuestionSet
    Player_1
    Player_2
    Player_3
    Player_4
    Player_1_Score 
    Player_2_Score
    Player_3_Score
    Player_4_Score
    Player_1_DisplayName
    Player_2_DisplayName
    Player_3_DisplayName
    Player_4_DisplayName
    Player_1_Round
    Player_2_Round
    Player_3_Round
    Player_4_Round
  }
}
`)

export default GameSubscription